    <!-- ======= Sidebar ======= -->
    <aside id="sidebar" class="sidebar">

      <ul class="sidebar-nav" id="sidebar-nav">

        <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" href="#">
            <i class="bi bi-menu-button-wide"></i><span>Услуги</span><i class="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul id="components-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">

            <li>
              <a href="/service/request/list">
                <i class="bi bi-circle"></i><span>Преглед на Заявки</span>
              </a>
            </li>

            <li>
              <a href="/service/request/all">
                <i class="bi bi-circle"></i><span>Заявени Услуги</span>
              </a>
            </li>

            <li>
              <a href="#" (click)="onServiceRequestShow()">
                <i class="bi bi-circle"></i><span>Заяви Услуга</span>
              </a>
            </li>
            <li>
              <a href="/admin/services">
                <i class="bi bi-circle"></i><span>Услуги</span>
              </a>
            </li>
          </ul>
        </li><!-- End Components Nav -->

        <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#forms-nav" data-bs-toggle="collapse" href="#">
            <i class="bi bi-journal-text"></i><span>Каса</span><i class="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul id="forms-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
            <li>
              <a href="/kasa" >
                <i class="bi bi-circle"></i><span>Преглед</span>
              </a>
            </li>
            <li>
              <a href="forms-layouts.html">
                <i class="bi bi-circle"></i><span>Дневна Справка</span>
              </a>
            </li>
            <li>
              <a href="forms-editors.html">
                <i class="bi bi-circle"></i><span>Обобщен Отчет</span>
              </a>
            </li>
          </ul>
        </li><!-- End Forms Nav -->



        <li class="nav-heading">Административни</li>

        <li class="nav-item">
          <a class="nav-link collapsed" href="/admin/users">
            <i class="bi bi-person"></i>
            <span>Потребители</span>
          </a>
        </li><!-- End Profile Page Nav -->

        <li class="nav-item">
          <a class="nav-link collapsed" href="/admin/orgs">
            <i class="bi bi-envelope"></i>
            <span>Организации</span>
          </a>
        </li><!-- End Contact Page Nav -->
        <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#tables-nav" data-bs-toggle="collapse" href="#">
            <i class="bi bi-layout-text-window-reverse"></i><span>Номенклатури</span><i class="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul id="tables-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
            <li>
              <a href="/admin/services">
                <i class="bi bi-circle"></i><span>Добави Услуга</span>
              </a>
            </li>
            <li>
              <a href="/admin/agents">
                <i class="bi bi-circle"></i><span>Добави Посредник</span>
              </a>
            </li>
            <li>
              <a href="/admin/serviceProviders">
                <i class="bi bi-circle"></i><span>Добави Доставчик</span>
              </a>
            </li>
            <li>
              <a href="/admin/documents">
                <i class="bi bi-circle"></i><span>Добави Документ</span>
              </a>
            </li>
            <li>
              <a href="/admin/documents/type">
                <i class="bi bi-circle"></i><span>Добави Документен Тип</span>
              </a>
            </li>
          </ul>
        </li><!-- End Tables Nav -->

      </ul>

    </aside><!-- End Sidebar-->
